<template>
    <div class="content_box mobile_content">
        <div class="content h5-quick-start-page">
            <!-- 标题栏 -->
            <div class="title_box title_flex" style="justify-content: space-between; align-items: center;">
                <div>
                    <h1 class="title">H5 快速开始页配置</h1>
                    <p style="margin:8px 0 0; color:#666; font-size:13px;">新用户扫码进入的快速开始页，配置产品信息和内容模块。App 下载和联系方式为全局配置，不在此维护。</p>
                </div>
                <div class="status_row">
                    <span class="status_pill">已发布</span>
                    <span style="margin-left:10px; font-size:13px; color:#666;">最近更新：{{ lastUpdateTime }}</span>
                </div>
            </div>

            <!-- 上方操作按钮 -->
            <div class="top_actions">
                <div class="button button2" @click="preview" style="background:#fff; border:1px solid #E8E9F1; color:#507FF7; margin-right:10px;">
                    <span>预览</span>
                </div>
                <div class="button button2" @click="saveDraft" style="margin-right:10px;">
                    <span>保存草稿</span>
                </div>
                <div class="button" @click="publish" style="background:#507FF7; color:#fff;">
                    <span>发布</span>
                </div>
            </div>

            <!-- 信息卡片 -->
            <!-- <div class="info_card">
                <div style="flex:1;">
                    <h2 style="font-size:15px; font-weight:850; margin-bottom:6px;">页面说明</h2>
                    <p style="color:#666; font-size:13px; line-height:1.55;">新用户扫码后看到的 H5 页面，包含产品信息、开箱安装视频、使用文档和联系方式。选择产品型号后自动带入产品名称和图片。</p>
                </div>
                <div class="source_list">
                    <span class="tag tag_ok">视频库</span>
                    <span class="tag tag_ok">文档库</span>
                </div>
            </div> -->

            <!-- 双列布局 -->
            <div class="layout_grid">
                <!-- 左列：配置区 -->
                <div class="left_col">
                    <!-- 页面范围 -->
                    <div class="config_card">
                        <div class="config_card_head">
                            <div>
                                <h2 class="config_card_title">页面基本信息</h2>
                            </div>
                        </div>
                        <div class="filters_grid">
                            <div class="filter_field">
                                <label>产品型号</label>
                                <el-select v-model="searchForm.product" placeholder="请选择产品" @change="onLangChange">
                            <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                                </el-select>
                            </div>
                            <div class="filter_field">
                                <label>当前编辑语言</label>
                                <el-select v-model="searchForm.lang" placeholder="请选择语言" @change="onLangChange">
                            <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                                </el-select>
                            </div>
                            <div class="filter_field">
                                <label>默认兜底语言</label>
                                <el-select v-model="searchForm.fallback" placeholder="请选择语言">
                                    <el-option label="English" value="en"></el-option>
                                    <el-option label="简体中文" value="zh"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <!-- 模块配置 -->
                    <div class="config_card" style="margin-top:16px;">
                        <div class="config_card_head">
                            <div>
                                <h2 class="config_card_title">模块配置</h2>
                                <p class="config_card_subtitle">每个模块只能添加对应类型的内容。模块标题根据多语言自动展示，不支持在此修改。</p>
                            </div>
                        </div>

                        <div class="modules_container">
                            <!-- Hero Banner 配置 -->
                            <div class="module_item" data-module="hero-banner">
                                <div class="module_header" @click="toggleModule('hero')">
                                    <div class="drag_handle" title="拖拽排序">⋮⋮</div>
                                    <div style="flex:1;">
                                        <p class="module_name">Hero Banner</p>
                                        <div class="module_meta">
                                            <span v-if="heroConfig.backgroundImage" class="tag tag_ok">已配置背景图片</span>
                                            <span v-else style="color:#999; font-size:12px;">未配置</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="module_body" v-show="!heroCollapsed">
                                    <div style="padding: 14px 0 14px 56px;">
                                        <el-form label-width="80px" :model="heroConfig" style="max-width: 400px;">
                                            <el-form-item label="背景图片">
                                                <div style="display: flex; align-items: center; gap: 8px;">
                                                    <span v-if="heroConfig.backgroundImage" style="font-size:12px; color:#666;">{{ heroConfig.backgroundImage.split('/').pop() }}</span>
                                                    <span v-else style="font-size:12px; color:#999;">未选择</span>
                                                    <div class="button text" @click="openHeroImageModal" style="color:#507FF7; font-weight:720; font-size:13px;">更换</div>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="标题">
                                                <el-input v-model="heroConfig.title" placeholder="请输入标题"></el-input>
                                            </el-form-item>
                                            <el-form-item label="副标题">
                                                <el-input v-model="heroConfig.subtitle" placeholder="请输入副标题"></el-input>
                                            </el-form-item>
                                            <el-form-item label="描述">
                                                <el-input v-model="heroConfig.description" placeholder="请输入描述信息" type="textarea" :rows="3"></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>

                            <!-- 模块1：开箱与安装视频 -->
                            <div class="module_item" data-module="unboxing-video">
                                <div class="module_header" @click="toggleModule('video')">
                                    <div class="drag_handle" title="拖拽排序">⋮⋮</div>
                                    <div style="flex:1;">
                                        <p class="module_name">开箱与安装视频</p>
                                        <div class="module_meta">
                                            <span>{{ videoItems.length }} 条内容</span>
                                            <span class="tag tag_ok">内容来自视频库</span>
                                        </div>
                                    </div>
                                    <div class="button text" @click.stop="openAddModal('video')" style="color:#507FF7; font-weight:720; font-size:13px;">+ 添加内容</div>
                                </div>
                                <div class="module_body" v-show="!videoCollapsed">
                                    <div class="content_list" ref="videoList">
                                        <div v-for="item in videoItems" :key="item.id" class="content_row_item">
                                            <div class="drag_handle drag_handle_sm">⋮</div>
                                            <div style="flex:1;">
                                                <div class="content_row_title">{{ item.title }}</div>
                                                <div class="content_meta">{{ item.description }}</div>
                                            </div>
                                            <div class="button text del_btn" @click="removeItem('video', item)">移除</div>
                                        </div>
                                        <div v-if="videoItems.length === 0" class="empty_hint">暂无内容，点击"+ 添加内容"开始配置</div>
                                    </div>
                                </div>
                            </div>

                            <!-- 模块2：使用文档 -->
                            <div class="module_item" data-module="user-doc" style="margin-top:12px;">
                                <div class="module_header" @click="toggleModule('doc')">
                                    <div class="drag_handle" title="拖拽排序">⋮⋮</div>
                                    <div style="flex:1;">
                                        <p class="module_name">使用文档（PDF）</p>
                                        <div class="module_meta">
                                            <span>{{ docItems.length }} 条内容</span>
                                            <span class="tag tag_ok">内容来自文档库</span>
                                        </div>
                                    </div>
                                    <div class="button text" @click.stop="openAddModal('doc')" style="color:#507FF7; font-weight:720; font-size:13px;">+ 添加内容</div>
                                </div>
                                <div class="module_body" v-show="!docCollapsed">
                                    <div class="content_list" ref="docList">
                                        <div v-for="item in docItems" :key="item.id" class="content_row_item">
                                            <div class="drag_handle drag_handle_sm">⋮</div>
                                            <div style="flex:1;">
                                                <div class="content_row_title">{{ item.title }}</div>
                                                <div class="content_meta">{{ item.description }}</div>
                                            </div>
                                            <div class="button text del_btn" @click="removeItem('doc', item)">移除</div>
                                        </div>
                                        <div v-if="docItems.length === 0" class="empty_hint">暂无内容，点击"+ 添加内容"开始配置</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="notice_box">
                            App 下载和联系方式为全局配置。联系方式根据用户所在国家自动展示对应内容，请在 系统管理 > 联系方式配置 中维护。<br>模块标题按 多语言管理 中的翻译自动展示，无需手动修改。
                        </div>
                    </div>
                </div>

                <!-- 右列：手机预览 -->
                <div class="right_col">
                    <div class="config_card preview_card">
                        <div class="config_card_head">
                            <div>
                                <h2 class="config_card_title">H5 预览</h2>
                                <p class="config_card_subtitle">{{ searchForm.lang === 'en' ? 'English' : searchForm.lang === 'zh' ? '简体中文' : 'Deutsch' }} / {{ currentProductName }}</p>
                            </div>
                            <div class="button text" @click="refreshPreview" style="color:#507FF7; font-weight:720; font-size:13px;">刷新</div>
                        </div>
                        <div class="phone_frame">
                            <div class="phone_container">
                                <div class="phone_h5_hero" :style="{ backgroundImage: heroConfig.backgroundImage ? `url('${heroConfig.backgroundImage}')` : 'linear-gradient(135deg, rgba(47, 109, 246, 0.12), rgba(49, 195, 214, 0.08))' }">
                                    <div class="h5_hero_top">{{ heroConfig.title || '快速开始' }}</div>
                                    <div class="h5_content_wrapper">
                                        <div v-if="heroConfig.subtitle" class="h5_subtitle">{{ heroConfig.subtitle }}</div>
                                        <div class="h5_product">{{ currentProductName }}</div>
                                        <div v-if="heroConfig.description" class="h5_description">{{ heroConfig.description }}</div>
                                    </div>
                                </div>
                                <div class="phone_content">
                                    <div class="phone_h5_section">
                                        <h5>App 下载</h5>
                                        <div class="phone_h5_download">
                                            <div class="phone_h5_dl_btn">iOS</div>
                                            <div class="phone_h5_dl_btn android">Android</div>
                                        </div>
                                    </div>

                                    <div v-if="videoItems.length > 0" class="phone_h5_section">
                                        <h5>开箱与安装视频</h5>
                                        <div v-for="vid in videoItems" :key="vid.id" class="phone_h5_video">
                                            <div class="play_icon">▶</div>
                                            <div class="vid_info">
                                                <div class="vid_title">{{ vid.title }}</div>
                                                <div class="vid_meta">{{ vid.description }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="docItems.length > 0" class="phone_h5_section">
                                        <h5>使用文档</h5>
                                        <div v-for="doc in docItems" :key="doc.id" class="phone_h5_doc">
                                            <div class="doc_dot">PDF</div>
                                            <div class="doc_info">
                                                <div class="doc_title">{{ doc.title }}</div>
                                                <div class="doc_meta">{{ doc.description }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="phone_h5_section">
                                        <h5>联系我们</h5>
                                        <div class="phone_h5_contact">
                                            <div class="ct_title">400-000-0000</div>
                                            <div class="ct_meta">周一至周五 09:00-18:00</div>
                                        </div>
                                        <div class="phone_h5_contact" style="margin-top:4px;">
                                            <div class="ct_title">support@example.com</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 添加内容弹窗 -->
            <Gh-Dialog size="true" ref="addModal" :title="`从${currentModalType === 'video' ? '视频库' : '文档库'}添加`" @dialogBack="confirmAdd">
                <template v-slot:cancel_btn>
                    <span></span>
                </template>
                <template v-slot:content>
                    <div class="modal_filter">
                        <label>产品</label>
                        <el-select v-model="modalForm.product" placeholder="请选择产品" >
                            <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                        </el-select>
                        <label>语言</label>
                        <el-select v-model="modalForm.lang" placeholder="请选择语言" style=" margin-right:10px;">
                            <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                        </el-select>
                        <div class="button" style="background:#507FF7; color:#fff; padding:6px 16px; font-size:13px;" @click="loadLibraryFiles">
                            <span>查 询</span>
                        </div>
                    </div>
                    <div class="modal_list">
                        <div v-for="file in filteredLibraryFiles" :key="file.name" class="modal_item" @click="selectFile(file)">
                            <div class="modal_check" :class="{selected: selectedFileItem && selectedFileItem.name === file.name}">
                                {{ selectedFileItem && selectedFileItem.name === file.name ? '✓' : '' }}
                            </div>
                            <div class="modal_item_content">
                                <div class="modal_item_title">{{ file.name.split('/').pop() }}</div>
                                <div class="modal_item_meta">{{ formatFileSize(file.size) }}</div>
                            </div>
                        </div>
                        <div v-if="filteredLibraryFiles.length === 0" class="modal_empty">该语言下暂无内容</div>
                    </div>
                    <!-- 文件选择后显示编辑字段 -->
                    <div v-if="selectedFileItem" class="modal_edit_form">
                        <el-divider></el-divider>
                        <el-form label-width="100px" :model="itemForm">
                            <el-form-item label="标题">
                                <el-input v-model="itemForm.title" placeholder="请输入标题"></el-input>
                            </el-form-item>
                            <el-form-item label="描述">
                                <el-input v-model="itemForm.description" placeholder="例如：3分20秒 或 3.2MB"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </template>
                <template v-slot:confirm_btn>
                    <div class="modal_foot">
                        <div class="modal_foot_actions">
                            <div class="button cancel" @click="closeAddModal">
                                <span>取消</span>
                            </div>
                            <div class="button" style="background:#507FF7; color:#fff;" @click="confirmAdd" :disabled="!selectedFileItem">
                                <span>确认添加</span>
                            </div>
                        </div>
                    </div>
                </template>
            </Gh-Dialog>

            <!-- Hero 图片选择弹窗 -->
            <Gh-Dialog size="true" ref="heroImageModal" title="选择 Hero 背景图片" @dialogBack="confirmHeroImage">
                <template v-slot:cancel_btn>
                    <span></span>
                </template>
                <template v-slot:content>
                    <div class="modal_filter">
                        <label>产品</label>
                        <el-select v-model="heroImageForm.product" placeholder="请选择产品" style="width:160px; margin-right:10px;">
                            <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                        </el-select>
                        <div class="button" style="background:#507FF7; color:#fff; padding:6px 16px; font-size:13px;" @click="loadHeroImages">
                            <span>查 询</span>
                        </div>
                    </div>
                    <div class="modal_list">
                        <div v-for="file in filteredHeroImages" :key="file.name" class="modal_item" @click="selectHeroImage(file)">
                            <div class="modal_check" :class="{selected: selectedHeroImage && selectedHeroImage.name === file.name}">
                                {{ selectedHeroImage && selectedHeroImage.name === file.name ? '✓' : '' }}
                            </div>
                            <div class="modal_item_content">
                                <div class="modal_item_title">{{ file.name.split('/').pop() }}</div>
                                <div class="modal_item_meta">{{ formatFileSize(file.size) }}</div>
                            </div>
                        </div>
                        <div v-if="filteredHeroImages.length === 0" class="modal_empty">暂无图片</div>
                    </div>
                </template>
                <template v-slot:confirm_btn>
                    <div class="modal_foot">
                        <div class="modal_foot_actions">
                            <div class="button cancel" @click="closeHeroImageModal">
                                <span>取消</span>
                            </div>
                            <div class="button" style="background:#507FF7; color:#fff;" @click="confirmHeroImage" :disabled="!selectedHeroImage">
                                <span>确认</span>
                            </div>
                        </div>
                    </div>
                </template>
            </Gh-Dialog>
        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'
import aliOss from '../../../aliOss/index'

export default {
    name: 'h5-quick-start',
    data() {
        return {
            // 筛选条件
            searchForm: {
                product: '',
                lang: 'zh',
                fallback: 'en'
            },

            // 产品列表
            productOptions: [],
            productMap: {},

            // 后台记录 ID
            recordId: '',
            isExistRecord: false,

            // 模块折叠状态
            videoCollapsed: false,
            docCollapsed: false,
            heroCollapsed: true,

            // Hero Banner 配置
            heroConfig: {
                backgroundImage: '',
                title: '快速开始',
                subtitle: '',
                description: ''
            },

            // 模块内容
            videoItems: [],
            docItems: [],

            // 弹窗状态
            currentModalType: '',
            modalForm: {
                product: '',
                lang: ''
            },
            filteredLibraryFiles: [],
            selectedFileItem: null,
            itemForm: {
                title: '',
                description: ''
            },
            heroImageModalType: '',
            heroImageForm: {
                product: ''
            },
            filteredHeroImages: [],
            selectedHeroImage: null,

            // 发布状态
            publishStatus: '已发布',
            lastUpdateTime: new Date().toLocaleString('zh-CN'),

            // 配置存储
            configData: {}
        }
    },

    computed: {
        currentProductName() {
            if (!this.searchForm.product) return ''
            return this.searchForm.product
        }
    },

    created() {
        this.getProductList()
    },

    mounted() {
        this.$nextTick(() => {
            this.initSortable('video')
            this.initSortable('doc')
        })
    },

    methods: {
        // 获取产品列表
        getProductList() {
            this.api.getIotProductList().then(res => {
                if (res.code === 0) {
                    this.productOptions = res.data
                    res.data.forEach(item => {
                        this.productMap[item.id] = item
                    })
                    if (res.data.length > 0) {
                        this.searchForm.product = res.data[0].id
                        this.modalForm.product = res.data[0].id
                        this.loadConfigData()
                    }
                }
            })
        },

        // 加载配置数据
        loadConfigData() {
            this.api.quickStartQuery({
                product: this.searchForm.product,
                language: this.searchForm.lang,
                status: 0
            }).then(res => {
                if (res.code === 200 && res.data && res.data.list && res.data.list.length > 0) {
                    const record = res.data.list[0]
                    this.recordId = record.id
                    this.isExistRecord = true

                    // 加载数据
                    const data = record.data || {}
                    this.heroConfig = data.heroConfig || {
                        backgroundImage: '',
                        title: '快速开始',
                        subtitle: '',
                        description: ''
                    }
                    this.videoItems = data.videoItems || []
                    this.docItems = data.docItems || []
                } else {
                    this.recordId = ''
                    this.isExistRecord = false
                    this.resetConfigData()
                }
            }).catch(() => {
                this.recordId = ''
                this.isExistRecord = false
                this.resetConfigData()
            })
        },

        // 重置配置数据
        resetConfigData() {
            this.heroConfig = {
                backgroundImage: '',
                title: '快速开始',
                subtitle: '',
                description: ''
            }
            this.videoItems = []
            this.docItems = []
        },

        // 产品变化处理
        onProductChange() {
            this.loadConfigData()
        },

        // 语言变化处理
        onLangChange() {
            this.loadConfigData()
        },

        // 打开添加模块
        openAddModal(type) {
            this.currentModalType = type
            this.selectedFileItem = null
            this.itemForm = {
                title: '',
                description: ''
            }
            this.modalForm.product = this.searchForm.product
            this.modalForm.lang = this.searchForm.lang
            this.loadLibraryFiles()
            this.$refs.addModal.show = true
        },

        // 关闭弹窗
        closeAddModal() {
            this.$refs.addModal.show = false
        },

        // 加载库文件列表
        loadLibraryFiles() {
            console.log('加载库文件:', this.modalForm.product, this.modalForm.lang)
            const module = this.currentModalType === 'video' ? 'teaching' : 'guide'
            const filePath = `${this.modalForm.product}/${this.modalForm.lang}/${module}`

            console.log(filePath)
            aliOss.getList(filePath).then(res => {
                console.log('库文件列表:', res)
                if (res.objects) {
                    this.filteredLibraryFiles = res.objects.filter(item => {
                        return item.name.split(module + '/')[1] != ''
                    })
                }
            }).catch(() => {
                this.filteredLibraryFiles = []
            })
        },

        // 选择文件
        selectFile(file) {
            this.selectedFileItem = file
            const fileName = file.name.split('/').pop()
            this.itemForm.title = fileName
            this.itemForm.description = this.formatFileSize(file.size)
        },

        // 格式化文件大小
        formatFileSize(bytes) {
            if (bytes < 1024) return bytes + 'B'
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + 'KB'
            return (bytes / (1024 * 1024)).toFixed(2) + 'MB'
        },

        // 确认添加
        confirmAdd() {
            if (!this.selectedFileItem || !this.itemForm.title) {
                this.$message.warning('请选择文件并输入标题')
                return
            }

            const module = this.currentModalType === 'video' ? 'teaching' : 'guide'
            const basePath = `product-service-center/${this.modalForm.product}/${this.modalForm.lang}/${module}`
            const fileUrl = 'https://neabot-en.oss-ap-southeast-1.aliyuncs.com/' + basePath + '/' + this.selectedFileItem.name.split('/').pop()

            const item = {
                id: Math.random().toString(36).substr(2, 9),
                name: this.selectedFileItem.name.split('/').pop(),
                title: this.itemForm.title,
                description: this.itemForm.description,
                url: fileUrl
            }

            const targetArr = this.currentModalType === 'video' ? this.videoItems : this.docItems
            targetArr.push(item)

            this.$refs.addModal.show = false
            this.$message.success(`已添加 ${this.itemForm.title}`)
        },

        // 打开 Hero 图片选择
        openHeroImageModal() {
            this.heroImageModalType = 'hero'
            this.selectedHeroImage = null
            this.heroImageForm.product = this.searchForm.product
            this.loadHeroImages()
            this.$refs.heroImageModal.show = true
        },

        // 关闭 Hero 图片选择
        closeHeroImageModal() {
            this.$refs.heroImageModal.show = false
        },

        // 加载 Hero 图片列表
        loadHeroImages() {
            console.log('加载Hero图片:', this.heroImageForm.product)
            const filePath = `${this.heroImageForm.product}/photo`

            console.log(filePath)
            aliOss.getList(filePath).then(res => {
                console.log('Hero图片列表:', res)
                if (res.objects) {
                    this.filteredHeroImages = res.objects.filter(item => {
                        return item.name.split('photo/')[1] != ''
                    })
                }
            }).catch(() => {
                this.filteredHeroImages = []
            })
        },

        // 选择 Hero 图片
        selectHeroImage(file) {
            this.selectedHeroImage = file
        },

        // 确认 Hero 图片
        confirmHeroImage() {
            if (!this.selectedHeroImage) {
                this.$message.warning('请选择图片')
                return
            }

            const basePath = `product-service-center/${this.heroImageForm.product}/photo`
            const imageUrl = 'https://neabot-en.oss-ap-southeast-1.aliyuncs.com/' + basePath + '/' + this.selectedHeroImage.name.split('/').pop()

            this.heroConfig.backgroundImage = imageUrl

            this.$refs.heroImageModal.show = false
            this.$message.success('背景图片已更新')
        },

        // 删除项目
        removeItem(type, item) {
            const arr = type === 'video' ? this.videoItems : this.docItems
            const idx = arr.indexOf(item)
            if (idx >= 0) {
                arr.splice(idx, 1)
            }
            this.$message.success('已移除')
        },

        // 初始化拖拽
        initSortable(type) {
            const refName = type + 'List'
            const el = this.$refs[refName]
            if (!el) return

            new Sortable(el, {
                handle: '.drag_handle_sm',
                animation: 150,
                onEnd: ({ oldIndex, newIndex }) => {
                    if (oldIndex === newIndex) return
                    const arr = type === 'video' ? this.videoItems : this.docItems
                    const moved = arr.splice(oldIndex, 1)[0]
                    arr.splice(newIndex, 0, moved)
                }
            })
        },

        // 折叠/展开模块
        toggleModule(type) {
            if (type === 'video') {
                this.videoCollapsed = !this.videoCollapsed
            } else if (type === 'doc') {
                this.docCollapsed = !this.docCollapsed
            } else if (type === 'hero') {
                this.heroCollapsed = !this.heroCollapsed
            }
        },

        // 预览
        preview() {
            this.$message.info('预览功能即将上线')
        },

        // 刷新预览
        refreshPreview() {
            this.$message.success('预览已刷新')
        },

        // 保存草稿
        saveDraft() {
            const configData = {
                heroConfig: this.heroConfig,
                videoItems: this.videoItems,
                docItems: this.docItems
            }

            if (this.isExistRecord && this.recordId) {
                // 更新已存在的记录
                this.api.quickStartUpdate({
                    id: this.recordId,
                    data: configData
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('草稿已保存')
                    } else {
                        this.$message.error('保存失败：' + res.message)
                    }
                }).catch(err => {
                    this.$message.error('保存失败')
                })
            } else {
                // 创建新记录
                this.api.quickStartCreate({
                    product: this.searchForm.product,
                    language: this.searchForm.lang,
                    status: 0,
                    data: configData
                }).then(res => {
                    if (res.code === 200) {
                        // 重新加载获取新的 recordId
                        this.loadConfigData()
                        this.$message.success('草稿已保存')
                    } else {
                        this.$message.error('保存失败：' + res.message)
                    }
                }).catch(err => {
                    this.$message.error('保存失败')
                })
            }
        },

        // 发布
        publish() {
            if (!this.isExistRecord || !this.recordId) {
                this.$message.warning('请先保存草稿再发布')
                return
            }

            this.api.quickStartPublish({
                product: this.searchForm.product,
                language: this.searchForm.lang,
                status: 0
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('发布成功')
                    this.publishStatus = '已发布'
                } else {
                    this.$message.error('发布失败：' + res.message)
                }
            }).catch(err => {
                this.$message.error('发布失败')
            })
        }
    }
}
</script>

<style lang="less" scoped>
@colorBlue2: #507FF7;
@colorBlue3: #E1EAFF;
@colorLine: #E8E9F1;
@colorDel: #EB534B;
@color333: #333;
@color666: #666;
@color999: #999;
@colorGreen: #21a67a;

.h5-quick-start-page {
    /deep/ .el-dialog__body {
        padding: 0 !important;
        max-height: 600px !important;
    }

    .title_flex {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 20px;
    }

    .status_row {
        display: flex;
        align-items: center;
        gap: 8px;
        color: @color666;
        font-size: 13px;
        white-space: nowrap;
    }

    .status_pill {
        height: 24px;
        display: inline-flex;
        align-items: center;
        padding: 0 9px;
        border-radius: 999px;
        background: #eef8f4;
        color: @colorGreen;
        font-size: 12px;
        font-weight: 800;
    }

    .top_actions {
        display: flex;
        gap: 10px;
        margin: 20px 0 30px;
        justify-content: flex-end;
    }

    .info_card {
        display: flex;
        gap: 20px;
        align-items: flex-start;
        margin-bottom: 20px;
        padding: 16px;
        border: 1px solid #dbe7ff;
        border-radius: 12px;
        background: linear-gradient(135deg, #f7fbff, #ffffff);

        h2 {
            font-size: 15px;
            font-weight: 850;
        }

        p {
            color: @color666;
            font-size: 13px;
            line-height: 1.55;
            font-weight: 640;
        }
    }

    .source_list {
        display: flex;
        gap: 8px;
        flex-shrink: 0;
    }

    .tag {
        height: 22px;
        display: inline-flex;
        align-items: center;
        padding: 0 8px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 760;

        &.tag_ok {
            background: #ebf9f4;
            color: @colorGreen;
        }
    }

    .layout_grid {
        display: grid;
        grid-template-columns: 1fr 340px;
        gap: 18px;
        align-items: start;
    }

    .config_card {
        border: 1px solid @colorLine;
        border-radius: 12px;
        background: #fff;
        overflow: hidden;
    }

    .config_card_head {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        padding: 14px 16px;
        border-bottom: 1px solid @colorLine;

        > div:first-child {
            flex: 1;
        }
    }

    .config_card_title {
        font-size: 16px;
        font-weight: 840;
        margin: 0;
    }

    .config_card_subtitle {
        margin: 4px 0 0;
        color: @color666;
        font-size: 12px;
        font-weight: 620;
    }

    .filters_grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        padding: 16px;
    }

    .filter_field {
        display: flex;
        flex-direction: column;
        gap: 6px;

        label {
            color: #4b5360;
            font-size: 12px;
            font-weight: 760;
        }

        .hint {
            color: @color999;
            font-size: 12px;
            font-weight: 620;
        }

        /deep/ .el-select {
            width: 100%;

            .el-input__inner {
                height: 38px;
                padding: 0 12px;
                border: 1px solid @colorLine;
                border-radius: 9px;
                font-size: 14px;
            }
        }
    }

    .product_preview_row {
        display: grid;
        grid-template-columns: 56px 1fr;
        gap: 14px;
        align-items: center;
        padding: 0 16px 16px;
        border-top: 1px solid #f0f2f5;
        margin-top: 14px;
    }

    .product_thumb {
        width: 56px;
        height: 56px;
        border-radius: 10px;
        background: linear-gradient(135deg, #eef3ff, #f0f7ff);
        display: grid;
        place-items: center;
        color: @colorBlue2;
        font-size: 18px;
        font-weight: 900;
    }

    .modules_container {
        padding: 0;
    }

    .module_item {
        border: 1px solid @colorLine;
        border-radius: 12px;
        background: #fff;

        &:not(:first-child) {
            margin-top: 12px;
        }
    }

    .module_header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px;
        cursor: pointer;
        user-select: none;

        &:hover {
            background: #f9f9fb;
        }
    }

    .drag_handle {
        width: 30px;
        height: 30px;
        display: grid;
        place-items: center;
        border-radius: 8px;
        background: #f7f8fb;
        color: #9aa2af;
        font-size: 18px;
        font-weight: 900;
        cursor: grab;
        flex-shrink: 0;

        &:active {
            cursor: grabbing;
        }

        &.drag_handle_sm {
            width: auto;
            background: none;
            padding: 0 6px;
            font-size: 14px;
            color: #c8ced8;
        }
    }

    .module_name {
        font-size: 15px;
        font-weight: 830;
        margin: 0;
    }

    .module_meta {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 5px;
        color: @color666;
        font-size: 12px;
        font-weight: 640;
    }

    .module_body {
        border-top: 1px solid @colorLine;
        padding: 0 14px 14px 56px;
    }

    .content_list {
        display: flex;
        flex-direction: column;
        gap: 0;
    }

    .content_row_item {
        display: grid;
        grid-template-columns: auto 1fr auto;
        align-items: center;
        gap: 12px;
        min-height: 52px;
        padding: 12px 0;
        border-bottom: 1px solid #f0f2f5;

        &:last-child {
            border-bottom: 0;
        }
    }

    .content_row_title {
        font-size: 14px;
        font-weight: 720;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .content_meta {
        font-size: 12px;
        color: @color999;
        display: block;
        margin-top: 4px;
    }

    .empty_hint {
        padding: 20px;
        text-align: center;
        color: @color999;
        font-size: 13px;
    }

    .notice_box {
        padding: 12px 14px;
        border-radius: 10px;
        background: #eef3ff;
        color: #2a5090;
        font-size: 13px;
        line-height: 1.45;
        font-weight: 640;
        margin: 0 16px 16px;
    }

    .right_col {
        .preview_card {
            position: sticky;
            top: 84px;
        }
    }

    .phone_frame {
        margin: 16px auto;
        width: 292px;
        min-height: 540px;
        overflow: hidden;
        border: 10px solid #111827;
        border-radius: 36px;
        background: #f6f7f9;
        box-shadow: 0 20px 42px rgba(17, 24, 39, 0.16);
    }

    .phone_container {
        background: linear-gradient(180deg, #fbfcff, #f5f7fb);
        min-height: 540px;
        overflow-y: auto;
    }

    .phone_h5_hero {
        min-height: 110px;
        padding: 14px;
        border-radius: 0 0 18px 18px;
        background: linear-gradient(135deg, rgba(47, 109, 246, 0.12), rgba(49, 195, 214, 0.08));
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 0 0 18px 18px;
        }
    }

    .h5_hero_top {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 8px 14px;
        font-size: 10px;
        color: #999;
        font-weight: 760;
        border-radius: 0 0 8px 8px;
    }

    .h5_content_wrapper {
        position: relative;
        z-index: 1;
        padding-top: 8px;
    }

    .h5_subtitle {
        font-size: 10px;
        color: #f0f0f0;
        font-weight: 640;
        margin-top: 10px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }

    .h5_product {
        font-size: 20px;
        font-weight: 880;
        color: #fff;
        margin: 2px 0 0;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    }

    .h5_description {
        font-size: 11px;
        color: #e8e8e8;
        margin-top: 4px;
        line-height: 1.4;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        max-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
        font-weight: 880;
        color: @color333;
    }

    .phone_content {
        padding: 10px;
        display: grid;
        gap: 8px;
    }

    .phone_h5_section {
        padding: 10px 12px;
        border-radius: 14px;
        background: #fff;

        h5 {
            font-size: 11px;
            font-weight: 800;
            margin: 0 0 7px;
        }
    }

    .phone_h5_download {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 6px;
    }

    .phone_h5_dl_btn {
        height: 32px;
        border-radius: 9px;
        background: #111827;
        color: #fff;
        display: grid;
        place-items: center;
        font-size: 10px;
        font-weight: 800;

        &.android {
            background: linear-gradient(135deg, #1a8f69, #2fc08c);
        }
    }

    .phone_h5_video {
        min-height: 42px;
        border-radius: 10px;
        background: linear-gradient(135deg, #dfeaff, #f0f7ff);
        margin-top: 6px;
        padding: 8px 10px;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .play_icon {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.88);
        display: grid;
        place-items: center;
        font-size: 10px;
        color: @colorBlue2;
        flex-shrink: 0;
    }

    .vid_info {
        flex: 1;
    }

    .vid_title {
        font-size: 9px;
        font-weight: 780;
        color: @color333;
    }

    .vid_meta {
        font-size: 8px;
        color: @color666;
        margin-top: 2px;
    }

    .phone_h5_doc {
        min-height: 36px;
        border-radius: 9px;
        background: #f7f9fd;
        margin-top: 6px;
        padding: 8px 10px;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .doc_dot {
        width: 24px;
        height: 24px;
        border-radius: 7px;
        background: #d99419;
        display: grid;
        place-items: center;
        color: #fff;
        font-size: 8px;
        font-weight: 900;
        flex-shrink: 0;
    }

    .doc_info {
        flex: 1;
    }

    .doc_title {
        font-size: 9px;
        font-weight: 780;
    }

    .doc_meta {
        font-size: 8px;
        color: @color666;
        margin-top: 2px;
    }

    .phone_h5_contact {
        min-height: 36px;
        border-radius: 9px;
        background: #fbfcff;
        margin-top: 6px;
        padding: 8px 10px;
    }

    .ct_title {
        font-size: 9px;
        font-weight: 780;
    }

    .ct_meta {
        font-size: 8px;
        color: @color666;
        margin-top: 2px;
    }

    .modal_filter {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 16px 24px;
        border-bottom: 1px solid #f0f2f5;

        label {
            font-size: 12px;
            font-weight: 760;
            color: #4b5360;
            white-space: nowrap;
        }

        /deep/ .el-select {
            width: 160px;
        }
    }

    .modal_list {
        overflow-y: auto;
        padding: 12px 0;
        max-height: 420px;
    }

    .modal_item {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        gap: 14px;
        padding: 14px 24px;
        cursor: pointer;

        &:hover {
            background: #f7f9fd;
        }

        &.selected {
            background: #eef3ff;
        }
    }

    .modal_check {
        width: 20px;
        height: 20px;
        border-radius: 6px;
        border: 2px solid #c8ced8;
        display: grid;
        place-items: center;
        flex-shrink: 0;
        color: #fff;
        font-size: 12px;
        font-weight: 800;

        &.selected {
            border-color: @colorBlue2;
            background: @colorBlue2;
        }
    }

    .modal_item_content {
        min-width: 0;
    }

    .modal_item_title {
        font-size: 14px;
        font-weight: 720;
    }

    .modal_item_meta {
        font-size: 12px;
        color: @color999;
        margin-top: 2px;
    }

    .modal_empty {
        padding: 40px 20px;
        text-align: center;
        color: @color666;
        font-size: 13px;
    }

    .modal_edit_form {
        padding: 16px 24px;
    }

    .modal_foot {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 16px 24px;
        border-top: 1px solid @colorLine;
        background: #fafbfc;
    }

    .modal_foot_actions {
        display: flex;
        gap: 8px;
    }

</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/h5-quick-start.vue